import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "feedback"]
  static classes = ["valid", "invalid"]

  initialize() {
    this.timeout = null
    this.debounceDelay = 300
  }

  connect() {
    // Validate on initial load
    this.validate()
  }

  validate() {
    // Clear any existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Debounce validation
    this.timeout = setTimeout(() => {
      const inputValue = this.inputTarget.value.trim()

      // If empty, it's valid (optional field)
      if (!inputValue) {
        this.showValid("Optional field")
        return
      }

      try {
        const parsed = JSON.parse(inputValue)

        // Check if it's an array
        if (!Array.isArray(parsed)) {
          this.showInvalid("Must be a JSON array")
          return
        }

        // Check if all items are strings
        if (!parsed.every(item => typeof item === 'string')) {
          this.showInvalid("All items in the array must be strings")
          return
        }

        // Check for empty strings
        const emptyStrings = parsed.filter(item => item.trim() === '')
        if (emptyStrings.length > 0) {
          this.showInvalid("Keywords cannot be empty strings")
          return
        }

        // Check for duplicates
        const uniqueItems = [...new Set(parsed)]
        if (uniqueItems.length !== parsed.length) {
          this.showInvalid("Duplicate keywords found")
          return
        }

        // If we get here, it's valid
        const count = parsed.length
        this.showValid(`Valid JSON array with ${count} keyword${count !== 1 ? 's' : ''}`)
      } catch (error) {
        this.showInvalid(`Invalid JSON: ${error.message}`)
      }
    }, this.debounceDelay)
  }

  showValid(message) {
    this.inputTarget.classList.remove("is-danger")
    this.inputTarget.classList.add("is-success")

    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = message
      this.feedbackTarget.classList.remove("is-danger", "has-text-danger")
      this.feedbackTarget.classList.add("is-success", "has-text-success")
    }
  }

  showInvalid(message) {
    this.inputTarget.classList.remove("is-success")
    this.inputTarget.classList.add("is-danger")

    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = message
      this.feedbackTarget.classList.remove("is-success", "has-text-success")
      this.feedbackTarget.classList.add("is-danger", "has-text-danger")
    }
  }
}
